import { forwardRef } from "react";
function SvgRawPauseIcon({ title, titleId, ...props }, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 32 32"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <rect width={7} height={22} x={7} y={5} fill="#1D1D1D" rx={1} />
      <rect width={7} height={22} x={18} y={5} fill="#1D1D1D" rx={1} />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgRawPauseIcon);
export default ForwardRef;
